import { styled } from '@mui/material/styles';
import { PickersDay } from '@mui/x-date-pickers-pro';
import React, { memo } from 'react';

// Original class: pickersDay
const StyledPickersDay = styled(PickersDay)(theme => ({
  width: 44,
}));

const CustomPickersDay = ({ date, currentDayObj, ...props }) => {
  const classes = useStyles();
  return (
    <StyledPickersDay
      outsideCurrentMonth={false}
      day={date}
      disableRipple
      isdayoff={`${currentDayObj.isDayOff}`}
      {...props}
    />
  );
};

export default memo(CustomPickersDay);
